window.toastr.options = {
  timeOut: 5000 // duration toast will display without user interaction
}

const displayToast = (details, type) => {
  if (!details) {
    return
  }

  const { title, message } = details
  if (!message) {
    return
  }

  if (!title) {
    return window.toastr[type](message)
  }
  window.toastr[type](message, title)
}

const info = details => {
  displayToast(details, 'info')
}
const error = details => {
  displayToast(details, 'error')
}
const warning = details => {
  displayToast(details, 'warning')
}
const success = details => {
  displayToast(details, 'success')
}

const confirmation = window.confirm.bind(window)

const clear = () => {
  window.toastr.clear()
}

export default {
  info,
  error,
  warning,
  success,
  confirmation,
  clear
}



// WEBPACK FOOTER //
// ./src/utils/notification.js